export class ResetPassRequestDTO {
    User: number;
    Token: string;
    NewPass: string;    
}